var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiAccountDetailsOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_account-details-outline",
    "data-name": "MDI / account-details-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_account-details-outline",
    "data-name": "Path / account-details-outline",
    d: "M11,9A3,3,0,1,1,8,6a3,3,0,0,1,3,3m3,11H2V18c0-2.21,2.69-4,6-4s6,1.79,6,4M7,9A1,1,0,1,0,8,8,1,1,0,0,0,7,9M4,18h8c0-1.1-1.79-2-4-2s-4,.9-4,2m18-6v2H13V12m9-4v2H13V8m9-4V6H13V4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAccountDetailsOutline);
export default __webpack_public_path__ + "static/media/MDI - account-details-outline.b0ffcfc93b2ba6db2ee878da68dd310f.svg";
export { ForwardRef as ReactComponent };